module.exports = __webpack_public_path__ + "static/img/why-3.a96ee64c.jpg";